import React, { Fragment } from "react";
import { MONTHS } from "./index";
const rightArrow = require("../../images/right-arrow.svg");
import _ from "lodash";

export const MonthPicker = ({
  year,
  setYear,
  month,
  setMonth
}: {
  year: number;
  setYear: (year: number) => void;
  month: number;
  setMonth: (month: number) => void;
}) => {
  return (
    <Fragment>
      {" "}
      <div className="flex-row year-row">
        <div className="small-label">Pick a year</div>
        <label className="select-label">
          <select
            name=""
            id="year-ddid"
            className="year-dd"
            defaultValue={year.toString()}
            onChange={e => setYear(parseInt(e.target.value))}
          >
            {_.range(2016, new Date().getFullYear() + 2).map(year => (
              <option value={year} key={year}>
                {year}
              </option>
            ))}
          </select>
          <img src={rightArrow} alt="" className="select-arr" />
        </label>
      </div>
      <hr />
      <div className="flex-row month-list">
        <div className="month-col">
          {_.take(MONTHS, 6).map((m: string) => (
            <a
              className={`month-single ${MONTHS[month] === m && "active"}`}
              key={m}
              onClick={() => {
                setMonth(MONTHS.indexOf(m));
              }}
            >
              {m}
            </a>
          ))}
        </div>
        <div className="month-col">
          {_.takeRight(MONTHS, 6).map((m: string) => (
            <a
              className={`month-single ${MONTHS[month] === m && "active"}`}
              key={m}
              onClick={() => {
                setMonth(MONTHS.indexOf(m));
              }}
            >
              {m}
            </a>
          ))}
        </div>
      </div>
    </Fragment>
  );
};
